// src/pages/Wallet.js
import React, { useState, useContext } from "react";
import "./ItemCSS.css";
import { FaShoppingCart } from "react-icons/fa";
import Header from "../components/Header";
import Footer from "../components/Footer";
import SEO from "../components/SEO";
import { CartContext } from "../context/CartContext";
import metalWalletPhoto from "../assets/newest-version/Full Front - Everything extended.jpg";

// Sample product data
const product = {
  id: 1,
  name: "Wallet",
  description:
    "Minimalistic wallet that holds all your daily essentials. Features an ID card holder, ample space for cards, cash, and add-ons, key holder, and an in-built tracking card. Designed to keep everything in one place.",
  price: 39.99,
  originalPrice: 39.99,
  discount: 39.99,
  link: "/wallet",
  images: [
    require("../assets/new-version/4.png"),
    require("../assets/new-version/5.png"),
    require("../assets/new-version/6.png"),
    require("../assets/new-version/7.png"),
    require("../assets/new-version/8.png"),
    require("../assets/new-version/9.png"),
    require("../assets/new-version/10.png"),
  ],
};

const Wallet = () => {
  // eslint-disable-next-line no-unused-vars
  const { addToCart } = useContext(CartContext);
  const [currentImage, setCurrentImage] = useState(0);

  return (
    <div>
      <SEO
        title="The Plastic Brik Wallet (Discontinued)"
        description="The original plastic Brik wallet has been discontinued. Shop the new metal version at $69.99."
        path="/wallet"
        robots="noindex, follow"
      />
      <Header />

      {/* Discontinued / cross-sell banners */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "8px",
          padding: "0",
          maxWidth: "900px",
          width: "90%",
          margin: "12px auto 0",
        }}
      >
        <div
          style={{
            background: "#fff4e5",
            border: "1px solid #ff7d1a",
            color: "#7a3b00",
            padding: "10px 16px",
            borderRadius: "8px",
            fontWeight: 600,
            textAlign: "center",
            fontSize: "14px",
          }}
        >
          This plastic wallet is no longer for sale. We've discontinued this
          version.
        </div>
        <a
          href="/metal-wallet"
          style={{
            background: "#111",
            color: "#fff",
            padding: "10px 16px",
            borderRadius: "8px",
            fontWeight: 700,
            textAlign: "center",
            textDecoration: "none",
            letterSpacing: "0.5px",
            fontSize: "14px",
          }}
        >
          Shop the new Metal Wallet for $69.99 &rarr;
        </a>
      </div>

      <div
        className="product-page1"
        style={{ minHeight: "auto", margin: "12px 0" }}
      >
        <div className="product-container1">
          {/* Image Gallery */}
          <div className="product-gallery1">
            <img
              src={product.images[currentImage]}
              alt="Product"
              className="main-image1"
            />
            <div className="thumbnails1">
              {product.images.map((img, index) => (
                <img
                  loading="lazy"
                  key={index}
                  src={img}
                  className={`thumbnail1 ${
                    index === currentImage ? "active1" : ""
                  }`}
                  onClick={() => setCurrentImage(index)}
                  alt="Thumbnail"
                />
              ))}
            </div>
          </div>

          {/* Product Details */}
          <div className="product-details1">
            <span className="company-name1">The Brik</span>
            <h1 className="product-title1">{product.name}</h1>
            <p className="description1">{product.description}</p>

            {/* Price Section */}
            <div className="price-section1">
              <div className="price1">
                <span className="current-price1">
                  ${product.price.toFixed(2)}
                </span>
              </div>
            </div>

            <div className="cart-actions1">
              {/* Add to Cart (disabled; product discontinued) */}
              <button
                className="add-to-cart1"
                disabled
                aria-disabled="true"
                title="This wallet is no longer for sale"
                style={{
                  opacity: 0.5,
                  cursor: "not-allowed",
                  pointerEvents: "none",
                }}
              >
                <FaShoppingCart /> Discontinued
              </button>
            </div>
            <p
              style={{
                marginTop: "10px",
                fontSize: "13px",
                color: "#888",
                fontStyle: "italic",
              }}
            >
              The plastic wallet has been discontinued.{" "}
              <a
                href="/metal-wallet"
                style={{ color: "#ff7d1a", fontWeight: 600 }}
              >
                Shop the metal version
              </a>
              .
            </p>
          </div>
        </div>
      </div>

      {/* Reviews Section */}
      {/* <div className="reviews-section">
        <div className="reviews-header">
          <h2>Customer Reviews</h2>
          <div className="average-rating">
            {reviews.length > 0
              ? (reviews.reduce((acc, r) => acc + r.rating, 0) / reviews.length).toFixed(1)
              : "No Reviews Yet"}/5
          </div>
        </div>

        <div className="reviews-list-container">
          <div className="reviews-list">
            {reviews.map((review, index) => (
              <div key={index} className="review-item">
                <div className="review-header">
                  <strong>{review.name}</strong>
                  <span className="review-stars">
                    {review.rating}/5
                  </span>
                </div>
                <p className="review-comment">{review.comment}</p>
              </div>
            ))}
          </div>
        </div>
      </div> */}

      {/* Product Section */}
      <section className="products6">
        <h2>Shop More Products</h2>
        <div className="product-container6">
          <div
            className="product-card6"
            onClick={() => (window.location.href = "/metal-wallet")}
            style={{ position: "relative", cursor: "pointer" }}
          >
            <div
              style={{
                position: "absolute",
                top: "12px",
                left: "12px",
                background: "#ff7d1a",
                color: "white",
                padding: "6px 14px",
                borderRadius: "20px",
                fontSize: "11px",
                fontWeight: 700,
                textTransform: "uppercase",
                letterSpacing: "1px",
                zIndex: 2,
                boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
              }}
            >
              In stock
            </div>
            <div style={{ background: "#dcdcdc", borderRadius: "16px", overflow: "hidden", width: "250px", height: "200px", maxWidth: "100%", margin: "0 auto 10px" }}>
              <img
                loading="lazy"
                src={metalWalletPhoto}
                alt="Metal Wallet"
                style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
              />
            </div>
            <h3>Metal Wallet</h3>
            <p>$69.99</p>
          </div>
          {/* 
          <div className="product-card6" onClick={() => window.location.href = "/card"}>
            <img loading="lazy" src={brikCard} alt="Brik Card" />
            <h3>Brik Card</h3>
            <p>$12.99</p>
          </div>

          <div className="product-card6" onClick={() => window.location.href = "/powerbank"}>
            <img loading="lazy" src={batterypack} alt="Powerbank" />
            <h3>Power Bank</h3>
            <p>$20.99</p>
          </div> */}
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Wallet;
